import {useEffect} from 'react';

import packageInfo from '../../package.json';
import envVariables from '../consts/envVariables';
import log from '../services/logger/log';

const useLogAppInfo = () => {
    useEffect(() => {
        log.info(
            `useLogAppInfo: UserAgent: ${navigator.userAgent}, App version: ${packageInfo.version}, Env: ${envVariables.ENV}`
        );
    }, []);
};

export default useLogAppInfo;
